import axios from '../../axios'

export default {
  getRelayMeasurements: function (callOptions) {
    return axios.get(axios.defaults.baseURL + 'influx/' + callOptions.pointName + '/' + callOptions.relayName + '/' + callOptions.relayType + '/' + callOptions.numberOfDays + '')
  }
}



// WEBPACK FOOTER //
// ./src/services/api/OilDigitalApi.js